import React from "react";
import Ample from "../components/ample/ample";
import {useSiteMetadata} from "../branding";
import { OutboundLink } from "gatsby-plugin-google-gtag";
import { Link } from "gatsby";

const PrivacyPage = (props) => {
    const siteMetadata = useSiteMetadata();
    return (
        <Ample currPageTitle="Privacy Policy" seoDescription="Privacy Policy" location={props.location.href}>
        
        <div className="white-box">
        <div className="box-title" style={{textTransform: 'none'}}>Privacy Policy</div>
        <p style={{color: "#666", fontSize: "0.95rem", marginTop: "12px"}}>
        Effective Date: March 1st 2024<br/><br/>
        Welcome to {siteMetadata.title}. This Privacy Policy outlines our practices regarding the use of cookies for advertising purposes and applies to all visitors, users, and others who access the website ("Users").
        </p>
        </div>

        <div className="white-box">
        <h4 className="card-title">1. Cookies and Advertising</h4>
            We do not collect personal information from Users directly. However, we use third-party advertising partners to display ads on our site, which use cookies to serve ads based on a User's prior visits to our website or other websites.
            Cookies are small data files stored on your device's hard drive or in device memory that help us improve our services and your experience, see which areas and features of our services are popular, and count visits.
        </div>
        
        <div className="white-box">
        <h4 className="card-title">2. Use of Cookies</h4>
            The cookies used for advertising purposes are designed to display relevant advertisements to you, improve reporting on campaign performance, and avoid showing ads you have already seen.
            Cookies do not include personal information about you but may track your internet usage for targeted advertising purposes.
        </div>

        <div className="white-box">
        <h4 className="card-title">3. Your Choices</h4>
        Most web browsers are set to accept cookies by default. If you prefer, you can usually choose to set your browser to remove or reject browser cookies. Please note that if you choose to remove or reject cookies, this could affect the availability and functionality of our ads.
        For more information about cookies and how to disable them, you can visit <OutboundLink href="https://www.allaboutcookies.org/">allaboutcookies.org</OutboundLink>
        </div>
        
        <div className="white-box">
        <h4 className="card-title">4. Third-Party Advertisers</h4>
        The third-party advertisers may use cookies to collect information about your activities on our website and other websites to provide you targeted advertising based upon your interests.
        This Privacy Policy does not apply to the cookies used by third-party advertisers and we are not responsible for their privacy policies and practices. Please visit the respective privacy policies of these third-party advertisers to learn more about their use of cookies.
        </div>

        <div className="white-box">
        <h4 className="card-title">5. Changes to This Privacy Policy</h4>
            We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Effective Date" at the top.
            You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.
        </div>
    
        <div className="white-box">
        <h4 className="card-title">6. Contact Us</h4>
        If you have any questions about this Privacy Policy, please <Link to="/contactus">contact us</Link>.
        </div>

      </Ample>);
}

export default PrivacyPage;